'use client';

import { BuilderComponent, useIsPreviewing } from '@builder.io/react';
import { builder } from '@builder.io/sdk';
import DefaultErrorPage from 'next/error';
import type { ComponentProps } from 'react';

import { PUBLIC_BUILDER_API_KEY } from './constants';

type BuilderPageProps = ComponentProps<typeof BuilderComponent>;

builder.init(PUBLIC_BUILDER_API_KEY);

export function RenderBuilderContent({ content, ...args }: BuilderPageProps) {
  // Call the useIsPreviewing hook to determine if
  // the page is being previewed in Builder
  const isPreviewing = useIsPreviewing();
  // If `content` has a value or the page is being previewed in Builder,
  // render the BuilderComponent with the specified content and model props.
  if (content || isPreviewing) {
    return <BuilderComponent content={content} {...args} />;
  }
  // If the `content` is falsy and the page is
  // DefaultErrorPage with a 404.
  return <DefaultErrorPage statusCode={404} />;
}
